import { Colors, Icon } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { MAINTEXT_COLOR, SUBTEXT_COLOR } from "@/css/constants";

interface SingleSelectProps {
  options: { label: string; value: string }[];
  value: string;
  onChange: (value: string) => void;
  placeholderLabel?: string;
}

export function SingleSelect({
  options,
  value,
  onChange,
  placeholderLabel,
}: SingleSelectProps) {
  return (
    <StyledContainer>
      <StyledSelect
        value={value}
        isPlaceholder={value === ""}
        onChange={(e) => onChange(e.target.value)}
      >
        {placeholderLabel && <option value="">{placeholderLabel}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledSelect>
      <IconContainer>
        <Icon icon="chevron-down" color={Colors.GRAY1} />
      </IconContainer>
    </StyledContainer>
  );
}

const StyledSelect = styled.select<{ isPlaceholder: boolean }>`
  appearance: none;
  font-size: 18px;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  padding: 6px 8px 6px 8px;
  border: 1px solid #ccc;
  background-color: ${Colors.WHITE};
  color: ${({ isPlaceholder }) =>
    isPlaceholder ? SUBTEXT_COLOR : MAINTEXT_COLOR};
`;

const StyledContainer = styled.div`
  display: flex;
  position: relative;
`;

const IconContainer = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
`;
